import { queryOptions } from '@tanstack/react-query';
import { getProcessingFees } from '../api/feePlans/methods';
import type { GetProcessingFeesRequestParams } from '../api/feePlans/types';

export const feePlans = {
  keys: {
    root: () => ['feePlan'],
    getProcessingFees: () => [...feePlans.keys.root(), 'getProcessingFees'],
  },
  // Methods
  getProcessingFees: (params: GetProcessingFeesRequestParams) => queryOptions({
    queryKey: [...feePlans.keys.getProcessingFees(), { params }],
    queryFn: async () => getProcessingFees(params),
  }),
};
